import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-action-success-alert',
  templateUrl: './action-success-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ActionSuccessAlertComponent {
  @Input()
  actionText: string;

  @Input()
  successText: string;

  @Input()
  redirectAction: () => any;

  @Output()
  closeClick = new EventEmitter<void>();

  actionClicked(): void {
    if (this.redirectAction) {
      this.redirectAction();
    }

    this.closeClick.emit();
  }
}
